import { GDFWmoCloudRecord } from '../../../gdf/type';

export default function WmoCloudTooltip({ record }: { record: GDFWmoCloudRecord }) {
    let type = '';
    switch (record.dist) {
        case 1: // skyclear
            type = 'SKC';
            break;
        case 2: // few
            type = 'FEW';
            break;
        case 3: // scattered
            type = 'SCT';
            break;
        case 4: // broken
            type = 'BKN';
            break;
        case 5: // overcast
            type = 'OVC';
            break;
        case 6: // scattered/broken
            type = 'SCTBKN';
            break;
        case 7: // broken/overcast
            type = 'BKNOVC';
            break;
        case 8: // Isolated
            type = 'ISOL';
            break;
        case 9: //Isolated/embedded
            type = 'ISOLEMBED';
            break;
        case 10: // occasional
            type = 'Occasional';
            break;
        case 11: // occasional/embedded
            type = 'Occasional/Embedded';
            break;
        case 12: // frequent
            type = 'Frequent';
            break;
        case 13: // dense
            type = 'DNS';
            break;
        case 14: // layers
            type = 'LYR';
            break;
    }
    return (
        <div style={{ whiteSpace: 'pre' }}>
            <div>Cloud</div>
            <div>Type: {type}</div>
            <div>Top: {record.cloudTops || '-'}</div>
            <div>Base: {record.cloudBase || '-'}</div>
        </div>
    );
}
